// Sets up a global event emitter that can be used to emit and listen to events across the app
// This file exports an instance, which is a singleton pattern to ensure that all parts of the app are using the same instance
// eventemitter3 conforms to https://nodejs.org/api/events.html
//
// Usage:
//   import eventEmitter from '~/shared/utils/event-emitter';
//
//   Publish an event:
//     eventEmitter.emit('event-name', data);
//
//   Subscribe to an event:
//     eventEmitter.on('event-name', (data) => {});
//
//     or if in react component:
//     useSubscribeToEmitterEvent('event-name', (data) => {});
//       handles unsubscribing automatically
//
import { EventEmitter } from 'eventemitter3';

const eventEmitter = new EventEmitter();

export default eventEmitter;
